<template>
  <div class="">
    <div
      v-for="(s,step) in sectorList"
      :key="s.id"
      class="my-2"
      :style="{'margin-left': `${(step +1 )*20}px`, cursor: 'pointer'}"
      @click.prevent="$emit('goto', s)"
    >
      <a
        class="text-dark "
        :class="[s.id === sector.id ?'font-weight-bold':'' ]"
      >- {{ s.name }}</a>
    </div>
  </div>
</template>

<script>

export default {
  name: "SectorPath",
  props: {
    sector: {
      default() {
        return null;
      }
    },
  },
  emits: ["goto"],
  data() {

    return {
      sectorList: []
    }
  },
  watch: {
    sector: {
      deep: true,
      handler() {
        this.sectorList = this.buildSectorList(this.sector);
      }
    },
  },

  mounted() {
    this.sectorList = this.buildSectorList(this.sector);
  },
  methods: {

    buildSectorList(sector) {

      let list = [];

      if (sector.parent !== null) {
        list = this.buildSectorList(sector.parent);
      }
      list.push(sector);

      return list;
    }

  }
}
</script>

<style scoped>

</style>